module.exports = __webpack_public_path__ + "img/Urlaub.ba955c2b.svg";